export default {"src":"/_next/static/media/check.8a279334.svg","height":227,"width":270,"blurWidth":0,"blurHeight":0};